import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import useHttp from "../../../hooks/useHttp";

import { hideModal } from "../../../store/slices/modal";
import { CANCEL_WITHDRAW_REQUEST_URL } from "../../../utils/api-ends";
import { withdrawListValue } from "../../../store/slices/withdraw";
import store from "../../../store";


const WithdrawConfirmModal = ({ modalData }) => {
  const dispatch = useDispatch();
  const closeModal = () => dispatch(hideModal());
  const { id } = modalData;
  const { error, sendRequests } = useHttp();
  const [withdrawError, setWithdrawError] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const withdrawData = useSelector((state) => state.withdraw);


  const openLoadManageModal = (e) => {
      const withdrawId = e.currentTarget.dataset.id;

      const response = (data) => {

          setWithdrawError(null)
          setSuccessMessage(data.message)
          setTimeout(function(){ closeModal() }, 2500);
          
          const withdrawArr = withdrawData.withdrawList.filter(function(item) {
              return item.id !== parseInt(withdrawId)
          })

          store.dispatch(
              withdrawListValue({
                withdrawValue: [...withdrawArr],
              })
          )

      };

      // Send request to Cancel withdraw request 
      sendRequests(
        {
          url: CANCEL_WITHDRAW_REQUEST_URL(withdrawId),
          method: "PATCH",
        },
        response
      );
  }



  useEffect(() => {
    if (error) {
      if (error.detail) {
        setWithdrawError(error.detail);
        setSuccessMessage("")
      }
    }

  }, [error]);




  return (
    <div className="col-xl-5 col-lg-8 col-md-10">
      <div className="load-add-edit-modal">
        <p className="auth-error withdraw-message-style">{withdrawError}</p>
        <p className="auth-instruction SuccessMessage_SuccessMsg__fTMdE withdrawAmount-success-message withdraw-message-style">{successMessage}</p>
        <div className="multiple-btn modal-button ">
          <button data-id={id} onClick={openLoadManageModal}> Confirm </button>
          <button onClick={closeModal}> Cancel </button>
        </div>
      </div>
    </div>
  );
};

export default WithdrawConfirmModal;
